<template>
  <el-config-provider :locale="elementLocale" :size="appStore.componentSize" :z-index="3000">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import { useAppStore } from '@/stores/app'

const appStore = useAppStore()

const elementLocale = computed(() =>
  appStore.language === 'zh-CN' ? (zhCn as never) : (en as never)
)
</script>
